// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__PLGbP","topBottomGutter":"Layout_topBottomGutter__1dP1-"};